import GameState from "slotworks/model/game-state";
import GambleResult from "slotworks/model/gameplay/records/results/gamble-result";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class IsGambleWin extends Decision {
    public evaluate() {
        const record = GameState.getCurrentGame().getCurrentRecord();
        const results = record.getResultsOfType(GambleResult);
        if (results.length > 0) {
            const result = results[results.length - 1];
            return (result.type === "win") ? Exit.True : Exit.False;
        } else {
            return Exit.False;
        }
    }
}
